module.exports = __webpack_public_path__ + "media/common/img/cheering_robot-da529e49c5ca930a3b2a2bba8cfebb08.svg";